export default class CategoryAddController {
  constructor(ProductPagesDataProvider, $state, Upload, $timeout, API_URL, APPLICATION_URL) {
    "ngInject"
    this.activeTab = 1;
    this.page = {};
    this.type = 2;
    this.page.products = [];
    this.Upload = Upload;
    this.ProductPagesDataProvider = ProductPagesDataProvider;
    this.$state = $state;
    this.$timeout = $timeout;
    this.API_URL = API_URL;
    this.APPLICATION_URL = APPLICATION_URL;
    this.errorShow = 0;
    this.field = 'id';
    this.order_type = 'asc';
    ProductPagesDataProvider.editor();
    let
      vm = this;
    ProductPagesDataProvider.loadCategoriesNoLimit(0).then(function (result) {
      vm.mainCategories = result;
    });
    vm.mainDomains = ["signlabs.se","signlabs.dk","signlabs.no","signlabs.fi","signlabs.de","signlabs.at","signlabs.ch","signlabs.es","signlabs.fr","signlabs.it","signlabs.nl","signlabs.be","signlabs.pl","signlabs.eu","signlabs.co.uk","signlabs.com","signlabs.loc"];
  }

  setActiveTab(tabToSet) {
    this.activeTab = tabToSet;
    this.setEditorsData();
  }

onvertToSlug(text) {
  return text
    .toString()
    .normalize('NFKD')                // Bryt ner bokstäver med diakritiska tecken
    .replace(/[\u0300-\u036f]/g, '')  // Ta bort diakritiska tecken (accents)
    .toLowerCase()
    .replace(/å/g, 'a')
    .replace(/ä/g, 'a')
    .replace(/ö/g, 'o')
    .replace(/æ/g, 'ae')
    .replace(/ø/g, 'oe')
    .replace(/\u00fc/g, 'ue')
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}

  saveData(productForm, redirect) {
    let
      vm = this;
    vm.setEditorsData();
    vm.$timeout(function () {
      if (!productForm.$valid) {
        vm.errorShow = 1;
        vm.$timeout(function () {
          vm.errorShow = 0;
        }, 5000);
        return false;
      }
      if (vm.page.name)
        vm.page.slug = vm.onvertToSlug(vm.page.name);
      if (!vm.page.alt)
        vm.page.alt = vm.page.name;
      vm.page.type = vm.type;
      vm.page.parent_id = vm.page.category_id;
      if (vm.page.img) {
        vm.saveWithImage(vm.page.img, redirect);
      }
      else {
        let
          saveData = vm.ProductPagesDataProvider.saveCategory(vm.page);
        saveData.then(function (res) {
          if (redirect == '1') {
            if (res.id != undefined)
              vm.$state.go("app.subCategoryEdit", {id: res.id, tabId: vm.activeTab});
            else if (res.exist == '1') {
              vm.errorShowExist = 1;
              vm.$timeout(function () {
                vm.errorShowExist = 0;
              }, 5000);
            }
            else
              alert('Please try again.')
          }
          else {
            vm.$state.go("app.subCategoryList", {parentId: 'all'});
          }
        })
      }

    }, 5);
  }

  saveWithImage(file, redirect) {
    let
      vm = this;
    file.upload = vm.Upload.upload({
      url: vm.API_URL + '/productPage/saveProductPageImage',
      method: 'POST',
      data: {
        filename: new Date().valueOf() + file.name,
        file: file
      }
    });
    file.upload.then(function (response) {
      let img = vm.page.img;
      let data = vm.page;
      data.img = vm.APPLICATION_URL + response.data;
      vm.ProductPagesDataProvider.saveCategory(data).then(function (res) {
        if (redirect == '1') {
          if (res.id != undefined)
            vm.$state.go("app.subCategoryEdit", {id: res.id, tabId: vm.activeTab});
          else
            alert('Please try again.')
        }
        else {
          vm.$state.go("app.subCategoryList", {parentId: 'all'});
        }
      })
    }, function (response) {
      if (response.status > 0)
        alert(response.status + ': ' + response.data);
    });
  }

  setEditorsData() {
    this.page.shortText = tinyMCE.get('shortText').getContent();
    this.page.templateText = tinyMCE.get('templateText').getContent();
    this.page.longText = tinyMCE.get('longText').getContent();
    this.page.metaData = tinyMCE.get('metaData').getContent();
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/product-page/components/subcategory_add/controller.js
 **/